const state = {
  exportTypes: null
}

const getters = {
  exportTypes: state => state.exportTypes
}

const mutations = {
  SET_EXPORT_TYPES (state, exportTypes) {
    state.exportTypes = exportTypes
  }
}

export default {
  state,
  getters,
  mutations
}
